export const URL_DASHBOARD  = "/dashboard";
export const URL_USER       = "/user";
export const URL_LOGIN      = "/login";